export const BXL_META_PREFIX = 'BXL_META_'

export const PAGE_LOCATION = 'H5_LG_P'

export const BXL_USER_ID = 'BXL_USER_ID'

export const BXL_USER_KEY = 'BXL_USER_KEY'

export const BASE_PATH = 'https://baleen-cdn-g.bybieyang.com'

export const BXL_META_device_id = "BXL_META_device_id";

export const BXL_GUEST_ID = "BXL_GUEST_ID";

export const DOWNLOAD_PAGE_PREFIX = 'https://baleen-cdn-g.bybieyang.com/static/html/appEntry/index.html'

export const BYH5 = 'https://baleen-cdn-g.bybieyang.com/static/html/byh5/index.html'

export const BYSTYLEUS_BASE_PATH = "https://dapper.bybieyang.com";

export const DOWNLOAD_LINK = 'http://sensorsdata.bybieyang.com:8006/track_installation?project=production&redirect_url=http%3A%2F%2Fa.app.qq.com%2Fo%2Fsimple.jsp%3Fpkgname%3Dcom.borderxlab.bieyang&data=eyJkaXN0aW5jdF9pZCI6Imlvc19jaGFubmVsX3RyYWNrX2lkIiwiZXZlbnQiOiIkQXBwQ2hhbm5lbE1hdGNoaW5nIiwicHJvcGVydGllcyI6eyIkdXRtX2NhbXBhaWduIjoidmVudWUxXzV0aCJ9LCJ0eXBlIjoidHJhY2tfaW5zdGFsbGF0aW9uIn0%3D'

export const renderToComponent: Record<string, string> = {
  ImageBox: "img",
  MixedBlocks: "mixedBlock",
  CustomTitle: "customTitle",
  NoticeBar: "noticebar",
  Block: "block",
  CombinationList: "combination",
  ProductList: "product",
  VideoBox: "video",
  SearchBar: "searchBar",
};

export const BASE_HOST: Record<string, string> = {
  grotto: "https://santa-grotto.santasmartnetwork.com",
  laas: "https://santa-laas.santasmartnetwork.com",
  ewe: "https://santa-ewe.santasmartnetwork.com",
};
